import { initAnchorNavigation } from "modules/AnchorNavigation";

(function (): void {
    initAnchorNavigation(".js-contact-support-page-template");

    // More to Explore: for exactly 2 cards use perView 2 on sm+ (both visible at 50%),
    // and perView 1 on mobile (slider). Only applies to this page.
    // Patches _recreateSlider so CardSlide's debounced resize doesn't reset our config.
    // Note: _keenSlider and _recreateSlider are internal properties set by CardSlide.ts —
    // update this if the CardSlide implementation changes.
    requestAnimationFrame(() => {
        const wrapper = document.querySelector("#more-to-explore");
        if (!wrapper) return;

        interface CardSlideElement extends HTMLElement {
            _keenSlider?: { update: (options: { slides: { perView: number; spacing: number } }) => void };
            _recreateSlider?: () => void;
        }

        const sliderEl = wrapper.querySelector<CardSlideElement>(".js-card-slide");
        if (!sliderEl) return;

        const slideCount = sliderEl.querySelectorAll(".slide").length;
        if (slideCount !== 2) return;

        const getPerView2Card = (): number => (window.innerWidth >= 768 ? 2 : 1);

        const apply2CardConfig = (): void => {
            if (!sliderEl._keenSlider) return;
            sliderEl._keenSlider.update({
                slides: { perView: getPerView2Card(), spacing: 24 },
            });
        };

        apply2CardConfig();

        const original = sliderEl._recreateSlider;
        sliderEl._recreateSlider = () => {
            original?.();
            apply2CardConfig();
        };
    });
})();
